// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieHolder_container__Utw8w","bannerLink":"CookieHolder_bannerLink__Tu6bf","closeButton":"CookieHolder_closeButton__evHrS"};